import * as React from "react";
import { useLocation } from "react-router-dom";

// The value used here is the last path segment in the URL
export enum SettingsTab {
  Organization = "organization",
  Tokens = "tokens",
  Usage = "usage",
  AI = "ai",
  Secrets = "secrets",
  Integrations = "integrations",
}

function deriveActiveTabFromUrl(path: string | undefined) {
  switch (path) {
    case SettingsTab.Tokens:
      return SettingsTab.Tokens;
    case SettingsTab.Usage:
      return SettingsTab.Usage;
    case SettingsTab.AI:
      return SettingsTab.AI;
    case SettingsTab.Secrets:
      return SettingsTab.Secrets;
    case SettingsTab.Integrations:
      return SettingsTab.Integrations;
    case SettingsTab.Organization:
      return SettingsTab.Organization;
    default:
      return SettingsTab.Organization;
  }
}

export function useActiveSettingsTab() {
  const location = useLocation();
  const path = location.pathname.split("/").pop();

  const [activeTab, setActiveTab] = React.useState(
    deriveActiveTabFromUrl(path),
  );

  React.useEffect(() => {
    setActiveTab(deriveActiveTabFromUrl(path));
  }, [path]);

  return [activeTab, setActiveTab] as const;
}
